import { GrpcWebFetchTransport } from '@protobuf-ts/grpcweb-transport';
import { BiankaServiceClient } from '@fiverr-private/bianka_js';
import { uid } from '@fiverr-private/futile';
import logger from '../../../logger/emitter';
import { createBiankaListener } from '../common';

/**
 * Creates a Web grpc bianka client instance.
 * @param baseUrl
 * @return {BiankaServiceClient}
 */
export const initBrowserClient = (baseUrl) => {
    const transport = new GrpcWebFetchTransport({ baseUrl, format: 'binary', timeout: 500 });

    return new BiankaServiceClient(transport);
};

/**
 * Formats reporting browser rpc headers.
 * @return {{url: string, referrer?: string}}
 */
export const formatBrowserHeaders = () => {
    const headers = {
        url: window.location.href
    };

    if (document.referrer) {
        headers.referrer = document.referrer;
    }

    return headers;
};

/**
 * Generates a UUID in a browser runtime.
 * @returns {`${string}-${string}-${string}-${string}-${string}`|string}
 */
export const generateUUID = () => typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : uid();

/**
 * The Bianka browser listener.
 * @param {BiankaListenerConfig} options
 * @return {BiankaListener}
 */
const biankaListener = (options = {}) => {
    const client = initBrowserClient(options.baseUrl);

    return createBiankaListener(options, {
        reportActivity: client.reportActivity.bind(client),
        reportBusiness: () => {
            logger.warn('Bianka "reportBusiness" API is available only for NodeJS runtime.');
        },
        formatHeaders: formatBrowserHeaders,
        generateUUID
    });
};

export default biankaListener;
